export const getTwoNumbersIfNotTen = (num: number) => {
  if (String(num).length < 2) return `0${num}`;
  return String(num);
};

export const secondsToHours = (seconds: number) => {
  if (seconds <= 0) return '00:00:00';
  const h = Math.floor(seconds / 3600);
  const hh = getTwoNumbersIfNotTen(h);
  const m = Math.floor((seconds - h * 3600) / 60);
  const mm = getTwoNumbersIfNotTen(m);
  const s = getTwoNumbersIfNotTen(seconds - h * 3600 - m * 60);
  return hh.concat(':').concat(mm).concat(':').concat(s);
};
